"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M5.42384 10.5199C5.15866 10.8381 5.20166 11.311 5.51987 11.5762L11.1998 16.3094C11.6633 16.6957 12.3367 16.6957 12.8002 16.3094L18.4801 11.5762C18.7983 11.311 18.8413 10.8381 18.5762 10.5199C18.311 10.2017 17.8381 10.1587 17.5199 10.4239L12 15.0237L6.48014 10.4239C6.16193 10.1587 5.68901 10.2017 5.42384 10.5199Z';